import { Command } from '../Command';
import { generateDefault } from '../../../lib/utils';
import { commandList } from '../../../lib/command-list';
import { validActivities } from '../../../lib/constants';

const LaunchActivityCommand = Command.extend({
  detail: {
    name: String,
    data: [Object],
    fieldsTransformToBlobs: [Array],
  }
}).defaultTo(
  generateDefault({
    action: commandList.LAUNCH_ACTIVITY
  })
);

export { LaunchActivityCommand };
